// extracted by mini-css-extract-plugin
export default {"MenuSection":"MenuSection__MenuSection___7mC34","scrollArea":"MenuSection__scrollArea___DTlMp"};